module.exports = __webpack_public_path__ + "img/map.9bd66ac1.jpg";